module.exports = "../../static/img/jzz.914e2cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/jzz.png
// module id = DGNZ
// module chunks = 35